<template>
  <div
    v-b-popover.hover.topright.html="getSpan( data.item.facility_name , 'Facility' )"
    class="hover-pointer"
    @click="
      $router.push({
        name: 'request-histories',
        params: { id: data.item.id }
      })
    "
  >
    <span
      style="font-size: smaller;"
    >
      <span>
        {{ getSmallName(data.item.facility_name) }}
      </span>
    </span>
  </div>
</template>

<script>

export default {
  name: 'FacilityNameCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    getSmallName: {
      type: Function,
      required: true,
    },
    getSpan: {
      type: Function,
      required: true,
    },
  },
}
</script>
